// The Comic Machine - Page

var Page = (function() {

  // A Page object to be managed by the Page Manager
  function Page(options) {

    options = options || {};

    // Assign the comic to the page
    this.comic = options.comic || Comic.current || null;

    // Set the index incrementally based on page count
    this.index = options.index || this.comic.pageList.length;
    this.uid = options.uid || generateUUID();
    this.id = options.id || null;
    this.name = options.name || "";

    // Set the page layer list
    this.pageLayers = options.layers || [];
    // Set the intiial layers if none specified
    if (this.pageLayers.length <= 0) {
      // Add the base layer
      this.pageLayers.push(new Layer({
        page: this,
        name: "base",
        type: Layer.Types.BASE
      }));
    }

    // Set the initial layer index
    this.layerIndex = options.layerIndex || 0;

    // Set the initial thumbnail image
    this.thumbnail = options.thumbnail || {
      url: "/images/page-thumbnail-default.png"
    };

  }

  // Method to add/insert a new page
  Page.addPage = function(comic, page, index, deselect) {

    comic = comic || Comic.current;

    var page = page || new Page({
      comic: comic
    });

    if (index) {
      // Insert a new page
      comic.pageList.splice(index, 0, page);
    } else {
      // Get new index based on current count
      index = comic.pageList.length;
      // Add a new page
      comic.pageList.push(page); // unshift
    }

    if (deselect !== true) {
      // Update the DOM
      Events.global.emit("tcm.page.update");
      // Select the new page
      Page.selectPage(comic, index);
    }

    // Return the page
    return page;

  };

  // Method to remove a page
  Page.removePage = function(comic, index) {

    comic = comic || Comic.current;

    if (!index) {
      return;
    }

    // Remove the page
    comic.pageList.splice(index, 1);

    // Reset the index if removing a page
    // TODO: Move to the nearest page instead
    if (comic.pageList[index] === comic.currentPage()) {
      comic.selectPage(0);
    }

    // Update the DOM
    Events.global.emit("tcm.page.update");

  };

  // Method to change pages
  Page.selectPage = function(comic, index) {

    comic = comic || Comic.current;

    if (index === undefined) {
      return;
    }

    // Update index and render the new page
    comic.pageIndex = index;
    comic.renderPage();

    // Update the DOM
    Events.global.emit("tcm.page.update");

    // Fire a custom event to notify listeners
    Events.global.emit("tcm.page.selected", {
      page: index
    });

    // Return the page
    return comic.currentPage();

  };

  // Method to get the current page
  Page.currentPage = function(comic) {
    comic = comic || Comic.current;
    return comic.currentPage();
  };

  // Method to get the page list
  Object.defineProperty(Page, "pageList", {
    get: function(comic) {
      comic = comic || Comic.current;
      return comic ? comic.pageList : null;
    }
  });

  // Method to get the page index
  Object.defineProperty(Page, "pageIndex", {
    get: function() {
      return Comic.current ? Comic.current.pageIndex : -1;
    },
    set: function(index) {
      Comic.current.pageIndex = index;
    }
  });

  // Method to get current layer
  Page.prototype.currentLayer = function() {
    return this.pageLayers[this.layerIndex];
  };
  // Method shorthand to get the current layer from the current page
  Page.currentLayer = function() {
    var page = Comic.currentPage();
    return page ? page.currentLayer() : null;
  };

  // Method to select a layer
  Page.prototype.selectLayer = function(index) {
    return Layer.selectLayer(this, index);
  };
  // Method shorthand to select a layer from the current page
  Page.selectLayer = function(index) {
    var page = Comic.currentPage();
    return page ? page.selectLayer(index) : null;
  };

  // Method to add a new layer
  Page.prototype.addLayer = function(layer, index, options) {
    return Layer.addLayer(this, layer, index, options);
  };
  // Method shorthand to add a new layer from the current page
  Page.addLayer = function(layer, index, options) {
    var page = Comic.currentPage();
    return page ? page.addLayer(layer, index, options) : null;
  };

  // Method to remove a layer
  Page.prototype.removeLayer = function(index) {
    Layer.removeLayer(this, index);
  };
  // Method shorthand to remove a layer from the current page
  Page.removeLayer = function(index) {
    var page = Comic.currentPage();
    return page ? page.removeLayer(index) : null;
  };

  // Method to get the current layer index
  Page.prototype.currentLayerIndex = function() {
    return this.layerIndex;
  };
  // Method shorthand to get the current layer index from the current page
  Page.currentLayerIndex = function() {
    var page = Comic.currentPage();
    return page ? page.currentLayerIndex() : null;
  };

  // Method to get a specific layer from the current page
  Page.prototype.getLayerByIndex = function(index) {
    var layer = this.pageLayers[index];
    return layer ? layer : null;
  };
  // Method to get a specific layer from the current page
  Page.getLayerByIndex = function(index) {
    var page = Comic.currentPage();
    var layer = page ? page.pageLayers[index] : null;
    return layer ? layer : null;
  };

  // Method to get a specific layer by the UID
  Page.prototype.getLayerByUID = function(uid) {
    var layer = null;
    this.pageLayers.forEach(function(item) {
      if (item.uid === uid) {
        layer = item;
      }
    });
    return layer;
  };

  // Method to edit an exisitng layer asset
  Page.prototype.editLayer = function() {

    var page = this;
    var uids = [];
    var collection = [];

    var fragment = document.createDocumentFragment();
    var container = document.querySelector(".layer-collection");
    var list = container.querySelector("ul");

    this.pageLayers.forEach(function(layer, i) {
      if (!layer.asset) {
        return;
      }
      if (uids.indexOf(layer.asset.uid) < 0) {
        uids.push(layer.asset.uid);
        var asset = JSON.parse(JSON.stringify(layer.asset));
        asset.layer = layer.uid;
        collection.push(asset);
      }
    });

    collection.forEach(function(asset, index) {
      var item = document.createElement("li");
      item.innerHTML = asset.name;
      item.className = "layer-item";
      item.setAttribute("data-index", index + 1);
      item.onclick = function(event) {
        event.preventDefault();
        page.addLayerTransition(asset, function() {
          container.setAttribute("data-active", "false");
        });
      };
      fragment.appendChild(item);
    });

    list.innerHTML = "";
    list.appendChild(fragment);
    container.setAttribute("data-active", "true");

  };
  // Method shorthand to edit an existing layer asset
  Page.editLayer = function() {
    var page = Comic.currentPage();
    return page ? page.editLayer() : null;
  };

  // Method to add a layer transition
  Page.prototype.addLayerTransition = function(asset, callback) {

    var page = this;
    var original = page.getLayerByUID(asset.layer);
    var edits = original.edits.length + 1;

    var options = {
      asset: asset,
      type: Layer.Types.IMAGE,
      action: Layer.Actions.MOVE,
      name: asset.name + "-edit-" + edits,
      width: original.size.width,
      height: original.size.height,
      original: asset.layer,
      x: original.position.x,
      y: original.position.y,
      preview: "end"
    };

    Asset.loadImage(API.config.assets + asset.url, function(image) {

      if (image) {
        options.content = image;
      }

      var mostRecent = original;

      page.pageLayers.forEach(function(pageLayer) {
        if (pageLayer.original === options.original) {
          mostRecent = pageLayer;
        }
      });

      var layer = page.addLayer(null, null, options);

      if (original.edits) {
        original.edits.push(layer.uid);
      }

      if (mostRecent !== original && mostRecent.edits) {
        mostRecent.edits.push(layer.uid);
      }

      if (mostRecent.size) {
        layer.size.width = mostRecent.size.width;
        layer.size.height = mostRecent.size.height;
      }

      if (mostRecent.position) {
        layer.position.x = mostRecent.position.x;
        layer.position.y = mostRecent.position.y;
      }

      if (mostRecent.transition && mostRecent.transition.end) {
        var end = clone(mostRecent.transition.end);
        layer.transition.start.set = true;
        layer.transition.start.x = end.x;
        layer.transition.start.y = end.y;
        layer.transition.start.width = end.width;
        layer.transition.start.height = end.height;
        layer.transition.start.opacity = end.opacity;
        layer.transition.end.x = end.x;
        layer.transition.end.y = end.y;
        layer.transition.end.width = end.width;
        layer.transition.end.height = end.height;
        layer.transition.end.opacity = end.opacity;
      } else if (mostRecent.size && mostRecent.position) {
        layer.transition.start.set = true;
        layer.transition.start.x = mostRecent.position.x;
        layer.transition.start.y = mostRecent.position.y;
        layer.transition.start.width = mostRecent.size.width;
        layer.transition.start.height = mostRecent.size.height;
        layer.transition.start.opacity = 1;
        layer.transition.end.x = mostRecent.position.x;
        layer.transition.end.y = mostRecent.position.y;
        layer.transition.end.width = mostRecent.size.width;
        layer.transition.end.height = mostRecent.size.height;
        layer.transition.end.opacity = 1;
      }

      // original.content = null;
      // original.canvas.resetCanvas();
      // Draw the image on the canvas
      layer.canvas.drawImage(image);
      // Set the thumbnail from the original
      layer.thumbnail = original.thumbnail; //.updateThumbnail();
      // Update the UI
      Events.global.emit("tcm.layer.update");

      callback && callback(layer);

    });

  }

  // Method to render the page layers together
  Page.prototype.renderPage = function() {

    var page = this;
    var handles = [];
    var offset = Canvas.size.offset;

    // Reset canvas to clear previous content
    Canvas.base.resetCanvas();
    Canvas.base.setScale(Canvas.base.scale);
    Canvas.drawCanvas();

    // Reset the handles list
    Canvas.base.handles = [];

    // console.log("render", "start");

    // Loop over the Page layers and draw to the cavnas
    this.pageLayers.forEach(function(layer, i) {

      var isBase = page.layerIndex === 0;
      var isCurrent = page.layerIndex === i;
      var isNewer = page.layerIndex < i;

      var hasOriginal = layer.original !== null;
      var hasEdits = layer.edits && layer.edits.length > 0;
      var lastEdit = hasEdits ? layer.edits[layer.edits.length - 1] : null;
      var lastLayer = page.getLayerByUID(lastEdit);
      var lastVisible = page.pageLayers.indexOf(lastLayer) <= page.layerIndex;

      var currentLayer = page.pageLayers[page.layerIndex];
      var originalLayer = page.getLayerByUID(layer.original);

      var isOriginal = currentLayer.original === layer.uid;
      var isInEdits = currentLayer.edits.indexOf(layer.uid) > -1;
      var isEdited = isOriginal || isInEdits;

      // Only render one action per image at a time
      // If no layer is selected, show the end of the each action
      // If layer is selected, show the selected action
      var skipCurrent = !isCurrent && (hasEdits && lastVisible) || isEdited;
      var skipLayer = isBase ? hasEdits : (skipCurrent || isNewer);

      // console.log( skipLayer ? "skiper" : "render", layer.name, {
      //    isBase: isBase,
      //    isCurrent: isCurrent,
      //    hasOriginal: hasOriginal,
      //    hasEdits: hasEdits,
      //    isEdited: isEdited
      // });

      if (skipLayer) {
        return;
      }

      var x = offset + layer.position.x + layer.offset.x;
      var y = offset + layer.position.y + layer.offset.y;
      var width = layer.size.width;
      var height = layer.size.height;
      var transition = layer.transition[isCurrent ? layer.preview : "end"];

      if (transition) {
        if (transition.x || transition.x === 0) {
          x = offset + transition.x;
        }
        if (transition.y || transition.y === 0) {
          y = offset + transition.y;
        }
        if (transition.width || transition.width === 0) {
          width = transition.width;
        }
        if (transition.height || transition.height === 0) {
          height = transition.height;
        }
      }

      // console.log("drawImage", x, y, width, height, layer);

      Canvas.base.drawImage(
        layer.canvas.element, {
          x: x,
          y: y,
        }, {
          x: width,
          y: height,
        }
      );

      // If is not the base layer, is the current layer and has content
      if (Layer.Types.BASE !== layer.type &&
        Page.currentLayer() === layer &&
        layer.content !== null &&
        transition.set === false) {
        handles.push({
          layer: layer,
          position: {
            x: x,
            y: y,
          },
          size: {
            x: width,
            y: height,
          },
        });
      }

    });

    // console.log("render", "end");
    // console.log("");

    // Draw the layer handles
    handles.forEach(function(handle, i) {
      Canvas.base.drawHandles(handle.layer, handle.position, handle.size);
    });

    var width = Canvas.base.element.width / Canvas.base.scale;
    var height = Canvas.base.element.height / Canvas.base.scale;

    // Draw mask layer over stage
    Canvas.base.context.lineWidth = offset;
    Canvas.base.context.strokeStyle = "rgba(0, 0, 0, 0.75)";
    Canvas.base.context.strokeRect(
      offset * 0.5,
      offset * 0.5,
      width - offset,
      height - offset
    );

    // Draw border layer over stage
    Canvas.base.context.lineWidth = 1;
    Canvas.base.context.strokeStyle = "rgba(255, 255, 255, 0.5)";
    Canvas.base.context.strokeRect(
      offset,
      offset,
      width - (offset * 2),
      height - (offset * 2)
    );

    // Set the initial thumbnail image
    if (this.thumbnail === "") {
      this.updateThumbnail();
    }

  };
  // Method shorthand to render the page layers from the current page
  Page.renderPage = function() {
    var page = Comic.currentPage();
    return page ? page.renderPage() : null;
  };

  // Method to create a thumbnail image of the page
  Page.prototype.generateThumbnail = function() {

    var page = this;
    var name = this.name.replace(/ /g, "-").toLowerCase();
    var canvas = new Canvas();

    // Draw the Canvas base layer
    Canvas.drawCanvas(canvas.context, 0.1);

    // Loop over the Page layers and draw to the canvas
    this.pageLayers.forEach(function(layer, i) {
      if (layer.edits.length > 0) {
        return;
      }
      canvas.drawImage(layer.canvas.element, {
        x: layer.position.x,
        y: layer.position.y,
      });
    });

    // Get the image data from the canvas
    var image = canvas.element.toDataURL("image/png");

    // Create the Blob file
    var file = base64toBlob(image.split(",")[1], "image/png");

    // Load the base64 data as an image
    Asset.loadImage(image, function(image) {
      // Ensure an image has loaded
      if (!image) return console.log(src, image);
      // Set the options for the asset
      var options = {
        name: name,
        image: image,
        file: file,
      };
      // Create the asset
      var asset = new Asset(options, function(asset) {
        asset.url = API.config.assets + asset.url;
        // Set the returned asset
        page.thumbnail = asset;
        // Update the UI
        Events.global.emit("tcm.page.update");
      });
    });

  };
  // Method shorthand to create a thumbnail image of the current page
  Page.generateThumbnail = function() {
    var page = Comic.currentPage();
    return page ? page.generateThumbnail() : null;
  };

  // Method to update the thumbnail image of the current page
  Page.prototype.updateThumbnail = function() {
    this.generateThumbnail();
  };
  // Method shorthand to update the thumbnail of the current page
  Page.updateThumbnail = function() {
    var page = Comic.currentPage();
    return page ? page.updateThumbnail() : null;
  };

  Events.global.on("tcm.layer.update", function() {
    Page.renderPage();
  });

  // Public / exposed class
  return Page;

})();
